import type { TFrameOptions, IRunPlan } from '../types';

const R = {
  doubleSlashes: /\/+/g
};

/**
 * create a run plan from a frame
 */
export class RunPlanBuilder {
  /**
   * load a run plan
   *
   * @param frameOptions
   * @returns
   */
  async create(frameOptions: TFrameOptions): Promise<IRunPlan> {
    const { remote_view, environment, host } = frameOptions;
    const path = `${host}/${remote_view}/${environment}.js`.replace(R.doubleSlashes, '/');
    const ver = frameOptions.debug ? '' : `?v=${crypto.randomUUID()}`;

    try {
      // add version to cache bust request
      //
      const { default: runPlan } = await import(`${path}${ver}`);
      if (!runPlan) {
        throw `loading run plan at ${path} - does not export a default`;
      }

      return runPlan;
    } catch (e) {
      throw `loading run plan at ${path} - ${e}`;
    }
  }
}
